<template>
  <div
    ref="echartsMap"
    :style="{ height: height, width: width }"
  />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";
import china from "../../../../public/lib/echart/json/china.json";

import anhui from "../../../../public/lib/echart/json/province/anhui.json";
import aomen from "../../../../public/lib/echart/json/province/aomen.json";
import beijing from "../../../../public/lib/echart/json/province/beijing.json";
import chongqing from "../../../../public/lib/echart/json/province/chongqing.json";
import fujian from "../../../../public/lib/echart/json/province/fujian.json";
import gansu from "../../../../public/lib/echart/json/province/gansu.json";
import guangdong from "../../../../public/lib/echart/json/province/guangdong.json";
import guangxi from "../../../../public/lib/echart/json/province/guangxi.json";
import guizhou from "../../../../public/lib/echart/json/province/guizhou.json";
import hainan from "../../../../public/lib/echart/json/province/hainan.json";
import hebei from "../../../../public/lib/echart/json/province/hebei.json";
import heilongjiang from "../../../../public/lib/echart/json/province/heilongjiang.json";
import henan from "../../../../public/lib/echart/json/province/henan.json";
import hubei from "../../../../public/lib/echart/json/province/hubei.json";
import hunan from "../../../../public/lib/echart/json/province/hunan.json";
import jiangsu from "../../../../public/lib/echart/json/province/jiangsu.json";
import jiangxi from "../../../../public/lib/echart/json/province/jiangxi.json";
import jilin from "../../../../public/lib/echart/json/province/jilin.json";
import liaoning from "../../../../public/lib/echart/json/province/liaoning.json";
import neimenggu from "../../../../public/lib/echart/json/province/neimenggu.json";
import ningxia from "../../../../public/lib/echart/json/province/ningxia.json";
import qinghai from "../../../../public/lib/echart/json/province/qinghai.json";
import shandong from "../../../../public/lib/echart/json/province/shandong.json";
import shanghai from "../../../../public/lib/echart/json/province/shanghai.json";
import shanxi from "../../../../public/lib/echart/json/province/shanxi.json";
import shanxi1 from "../../../../public/lib/echart/json/province/shanxi1.json";
import sichuan from "../../../../public/lib/echart/json/province/sichuan.json";
import taiwan from "../../../../public/lib/echart/json/province/taiwan.json";
import tianjin from "../../../../public/lib/echart/json/province/tianjin.json";
import xianggang from "../../../../public/lib/echart/json/province/xianggang.json";
import xinjiang from "../../../../public/lib/echart/json/province/xinjiang.json";
import xizang from "../../../../public/lib/echart/json/province/xizang.json";
import yunnan from "../../../../public/lib/echart/json/province/yunnan.json";
import zhejiang from "../../../../public/lib/echart/json/province/zhejiang.json";

const provinces = {
  台湾: taiwan,
  河北: hebei,
  山西: shanxi,
  辽宁: liaoning,
  吉林: jilin,
  黑龙江: heilongjiang,
  江苏: jiangsu,
  浙江: zhejiang,
  安徽: anhui,
  福建: fujian,
  江西: jiangxi,
  山东: shandong,
  河南: henan,
  湖北: hubei,
  湖南: hunan,
  广东: guangdong,
  海南: hainan,
  四川: sichuan,
  贵州: guizhou,
  云南: yunnan,
  陕西: shanxi1,
  甘肃: gansu,
  青海: qinghai,
  新疆: xinjiang,
  广西: guangxi,
  内蒙古: neimenggu,
  宁夏: ningxia,
  西藏: xizang,
  北京: beijing,
  天津: tianjin,
  上海: shanghai,
  重庆: chongqing,
  香港: xianggang,
  澳门: aomen,
};

const _ = require("lodash");
import icon from '@/assets/icon-7.png'

export default {
  name: "HeguMapEchart",
  mixins: [chartResize],
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    poiList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    poiParams: {
      type: Object,
      default: () => {
        return {
          color: "#30c5ff",
          type: "scatter",
          name: "name",
          valueField: "",
          symbol:'img_poi_white'
        };
      },
    },
    heatParams:{
       type: Object,
      default: () => {
        return {
          valueField: 'value',
        };
      },
    },
    heatData:{
      type: Array,
      default: () => {
        return [];
      },
    },
    currentCode: {
      type: String,
      default: "100000",
    },
    currentName: {
      type: String,
      default: "全国",
    },
    currentLevel: {
      type: Number,
      default: 1,
    },
    parentName: {
      type: String,
      default: null,
    },
    parentLevel: {
      type: Number,
      default: -1,
    },

    showBack: {
      type: Boolean,
      default: true,
    },
    mapStyle: {
      type: Number,
      default: 1,
    },
    bMapJson: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imgs: {
        img_poi:
          "image://data:image/png;base64,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",
        img_poi_red:
          "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAiCAYAAABBY8kOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0YmNjNzlkMS03NTllLTg1NDUtOGRiNi0yNGExYWM1N2NmMTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEEwNzc3RDE4NjAzMTFFQUFDRjA4QjgwMDE3MjU4NzAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEEwNzc3RDA4NjAzMTFFQUFDRjA4QjgwMDE3MjU4NzAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmQ2NDc5YmFmLTBmNzgtODQ0Ny04ZGY3LTdjMmJlZjNlZWJkOCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0YmNjNzlkMS03NTllLTg1NDUtOGRiNi0yNGExYWM1N2NmMTkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz457V/nAAACX0lEQVR42ryWTWjTYBjH/00iY1N68DYPgjeF6cmjl3bMQbcOqU78uOhJdrLIHM5i0Tmcojt7UUFBGHqyiIzZMVFEBEHcDu6gF6nQUSrd5iqt3eL/fZe6ONMm6ZI+8AtPvp5f8ubNkwT0cBg2sZf0kxDZR3Ya23+Qz2SGPMX09Hy9IgG9s7PWvoPkBumCs3hJLiOd/mAt6vqvjkauk4tEhbtYJbfJFUxNVf4VdXeb11vlMAA92Fo8J8cxOfmrukGBosBAJROkx7StUXplrUhEtRJdIn0eSKr0yZp/hy4arc6sWbIN3sZvcgCp1Lwm7cA1HyQwal4lJwJ6LLaLybcGZpibmbhb3NFRHyUwasc0qGoI/kdIiDqaIOoQovYmiNqFaEcTRK1C9JOJ37K8EGWMF9bPyArRbBNEc0I0Izutv5EWogkmd8h2nyTiU/FMQ1tbAaXSI64M+CR6iPHxgrbeJNQRLk+ToNezjSSrn20utSx0/QKzex6LzmNsLLchkl+mwH022EPMzngkuYnR0cfmHxFTn1XPiZZOwluUpEhi8x/PRlQqZbS0xJi9IfsblHwiJ5FMrtUWiSiVFjkTI8xekz0uJaLL9CKRKG7eoVgeXixm+LwOk5yLn5FFEqEkY1VSqXltKytf+MyipEhgQ5kcwfDwXK1ySt2BWFp6z6s8S3SbuxnA0NCreqUU21EvFJ6w0EgdyV0MDj6wK6M4esTrohcWkrck7qiEs0aSX2PBU+SrSfKdHEM8XvZOJCKXE7Oqnx0EEpHn81mnp2uu3pKFhY8IBm/J85aX30mhw/gjwAB9x4tvSJnqaQAAAABJRU5ErkJggg==",
        img_poi_unit:
          "image://data:image/png;base64,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",
        img_poi_white:
          "image://data:image/png;base64,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",
      },
      icon:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAAAXNSR0IArs4c6QAAAfFJREFUOE+F00uIzmEUx/HPcUth5X5ZUKyUKKWUWAnZIGxlKfesRJSaBQmZYRjXYmExyI71bGxkRUpZWLjfM+4enfG8Y3q9w6l/vf+3//N9zu/3Oyc0VSllOFbjAMbiJI5FxIvmb5vfY+AfFTQPB7EIQ/AkYeiKiNf/AjbDErQfy5EdNuop2tEZEa8GA/bDSikjsAJHML3FgWc4kbIHk9wHK6WMw0J8wxxswdQWwOfVw45WwAZsAU7hHtqwFLsweRBgJxKY8P5qwGZX2FxcrnISuBOTWgAz2S4cj4j0s68asDR7CQ5hJi7gNFZiGya0AGYQ2WEC08/fsOrbMCzDPszCeZzBmuph+tpcL6ui9uwwSimj6zx9wFAsxmHMqN2dw9r/APPSiwnbix/IQ9+r3PlYVf1KKSk7O9yK8S06fIfuhKX2XhxFSt2IHtzFJkypHZ6twO1olpznexKWP3JgM5Vcn0zvWjU+E80dHVPNTuD62mHubSrKdevGjYS9xyh8qk92mqlewsja3Y56YQeuYAPW4QHygpt4k7CP+ImruFVvuhMRbwdsx2bkkyOU/mXS0/AY9yPia99olFI+I4G54BlCb0SUgSaXUiZWWKZ6G7vz0ojIJv5sQCnlYU1xD65HRCb6V5VScnBzXDK5RxHxpfmjX93+rcWebU4uAAAAAElFTkSuQmCC',
      playIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAABr0lEQVQ4jZXUvWsVURAF8N/bkESFmARbxSAiIphCsbGwENSA4BcWNoKFpVZioX+BraiNVTqJX9jEoK1oY6cERPELUSEgCImYIC/HYt+Tx7JrkgPD3Ts7c+bu3jPTSqIGe3EeWzCMPrQxj++YxLNqUquG7B7G8AKP8Ro/sRG7MIED+IEznQIlknRtOMlckpkkQz3+OutLMpVkIcnWrr/7sj/JtyQ3VyCp2tUkv5NsSvLvM6cwgiN1P3AF3MZ2HJRkPMmXhsqtJLtXccL3SSYKXMKjhqqX8QpPsfM/p5vExQKb8aAhaF9nPYRZXGiIu4/1BQaU11+HhZ7nAjfwBKOVuLdYKjCo1FEd6hR9uHPSXrSxXOAPhhrIWjW+d3heE9cqsKRUdh02VPa3MI6vFf82DBaYw6kGss+d9SOOKS9gsSbuJNqS7E/yoUE/I0lOJBlYQWezSU53N9NJ7qyxlbp2LcnL3t4cSTKf5Moaic6lxFgvmU73LyaZXCXR9STLSfZ0fdV5NoqHWIdpzOANfnV8O5Q6O45+5Tz71E2uG45wFGeVU5ZSlC3lxJ1XDtC71aS/tKbl41SUxgMAAAAASUVORK5CYII=",
      unPlayIcon:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrUlEQVQ4jYXUz4tOURzH8ddzBmMUk6wU0SyY/NrIhhWFERElSoqSlVlJ8g88KSsmG6spoh5DShILmwkrG9JgFsxCpOQpPzJ0sThncl3nPs9nc+799jnv+73f8z3fRqvVktF6HMNS9KMHBT7jHUYxXt00KwO6juV4hBE8QxsLsApDOIePOJg+8B+sH5N4gi1lU9I3vMeDlOnVlOVqTEFIxtmYQAs7MqCqChxAEy+wqAy7kn7nRBdIVU1cFksjYB02YnvG3MDaLsDjWIahgJO4VWM8hae4j8EOwFEMByzBjRrThrRuxXP1ZRhDX8AcsV45fSk9B7FV7mFhxfcK0wG9Yh/l9DsT25YyLavAr4CfmF8Da2Rik3iY8TUCpsXOzmle5f2iePpvK/EB9AZ8wL4a2FRaX2O3eADfM769KAIudIA1k3EQt2s8cBSXgnihJ3AtY2qLPfijA+iseG/HZq7TIezCmQ6bcjqC09jP36nRxhq8xMpk6qbzGBZn35syjFjsxbiJx7iDu+JU+Iq5WCH22R5x0gzMgKow+ITN2InD2JTihdhLPeJ4GhHH1T/6A3afXD69+9eXAAAAAElFTkSuQmCC',
      chart: null,
      geoCoordMap: {
        江苏: [118.8062, 31.9208],
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.9236, 43.5883],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        上海: [121.4648, 31.2891],
        西藏: [91.11, 29.97],
      },
      amap: null,
      history: [], //下钻过程中记录历史，方便返回
      // currentLevel: 1, // 目前所在层级
      // currentName: "全国", //当前的地图名字
      // currentJson: china, //当前的json
      // currentCode: "100000",
      // parentName:'',
      // parentLevel:'',
      mapData: [],
      zoom: 1.2,
    };
  },
  watch: {
    currentCode(newVal){
      this.currentCode = newVal
      this.initChart();
    },
    poiList() {
      if (this.chart == null) {
        this.initChart();
      }
      this.chart.clear();
      this.updateChart();
    },
    heatData() {
      if (this.chart == null) {
        this.initChart();
      }
      this.chart.clear();
      this.updateChart();
    },
    mapJson(){
      if (this.chart === null) {
        this.initChart()
      }
      this.updateChart();
    },
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 100);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      var that = this,
        { currentName, currentLevel, currentCode } = this;
      const el = this.$refs.echartsMap;
      let chart = echarts.init(el);
      that.chart = chart;
      echarts.registerMap(
        that.currentName == "全国" ? "china" : "map",
        that.setMapJson()
      );
      window.addEventListener("resize", () => {
        setTimeout(() => {
          chart.resize();
        }, 500);
      });
      chart.off("click");
      chart.on("click", (params) => {
        console.log(params)
        if (params.componentType == "geo") {
          that.mapData.map((item) => {
            if (item.name == params.name) {
              that.$emit("clickArea", {
                item,
                currentName,
                currentLevel,
                currentCode,
              });
            }
          });
        }else if(params.componentType == "series" && params.componentSubType == 'scatter'){
          that.$emit("clickPoi", params.data.data);
        }
      });
      that.updateChart();
    },
    goDown(param, parentName, parentLevel, parentCode) {
      //先判断可不可以下钻
      if (this.currentLevel > 2) {
        return false;
      }
      this.currentLevel = this.currentLevel + 1;
      this.currentName = param.name;
      this.currentCode = param.cityCode;
      // this.parentName = parentName
      // this.parentLevel = parentLevel
      // this.parentCode = parentCode
      this.history.push({
        parentName,
        parentLevel,
        parentCode,
      });
      this.$echarts.registerMap(
        this.currentName == "全国" ? "china" : "map",
        this.setMapJson()
      );
      this.updateChart();
    },
    goUp(param) {
      if (this.history.length == 0) {
        return;
      }
      this.history.slice(this.history.length - 1);
      this.currentLevel = this.currentLevel - 1;
      this.currentName = param.name;
      this.currentCode = param.cityCode;
      this.$echarts.registerMap(
        this.currentName == "全国" ? "china" : "map",
        this.setMapJson()
      );
      this.updateChart();
    },
    goBack() {
      let { parentName, parentLevel, parentCode } = this.history[
        this.history.length - 1
      ];
      this.$emit("goBack", {
        name: parentName,
        cityCode: parentCode,
        level: parentLevel,
      });
    },
    setMapJson() {
      if (this.bMapJson) {
        return JSON.parse(this.bMapJson);
      }
      let mapJson = null;
      if (this.currentLevel == 1) {
        mapJson = china;
      } else if (this.currentLevel == 2) {
        mapJson = provinces[this.currentName];
      } else {
        const jsons = provinces[this.parentName].features.filter((item) => {
          item.properties.name == this.currentName;
        });
        mapJson = {
          type: "FeatureCollection",
          features: jsons,
        };
      }
      this.mapData = [];
      for (let i = 0; i < mapJson.features.length; i++) {
        var curEle = mapJson.features[i].properties;
        this.mapData.push({
          name: curEle.name,
          value: curEle.cp,
          //value: Math.random() * 100,
          cityCode: mapJson.features[i].id,
          level: this.currentLevel + 1,
        });
      }
      return mapJson;
    },
    getScatterSeriesByImg() {
      var that = this,
        { poiList, poiParams, playIcon, unPlayIcon } = this;
      return {
        name: poiParams.name,
        type: "scatter",
        zIndex: 3,
        coordinateSystem: "geo", //[poiParams.symbol]
        symbol: poiParams.symbol
          ? that.imgs[poiParams.symbol]
          : that.imgs.img_poi,
        symbolSize: [20, '26'], // [16,20], //[300,200],  //
        label: {
          normal: {
            show: true,
            formatter: function(params) {
              console.log(params)
              if(params.data.data.onlineStatus == 1){

                return ( "{fline|" + '' + "}{tline|  " + params.name + "}");
              }else{
                 return ( "{fline2|" + '' + "}{tline|  " + params.name + "}");
              }
            },
            position: "top", //  top
            y: 20,
            backgroundColor:'transparent',
            backgroundColor: "rgba(43,200,255,0.7)", //  'rgba(8,186,236,.9)',
            padding: [10, 42],
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "#D2ECFF",
            lineHeight: 20, //32
            color: "#ffffff",
            rich: {
              fline: {
                marginRight:10,
                height:16,
                backgroundColor:{
                  image:playIcon
                }
              },
              fline2:{
                marginRight:10,
                height:16,
                backgroundColor:{
                  image:unPlayIcon
                }
              },
              tline: {
                color: "#ffffff",
                fontSize:16
              },
            },
          },
          emphasis: {
            show: true,
           
            backgroundColor: "rgba(0,184,36,0.7)", //  'rgba(8,186,236,.9)',
          },
        },
        data: that.convertData(poiList, poiParams),
        zlevel: 3,
      };
    },
    //闪烁点数据
    getScatterSeries() {
      var that = this,{ poiList, poiParams } = this;
      return {
        name: poiParams.name + '涟漪图',
        type: "effectScatter",
        coordinateSystem: "geo",
        zlevel: 2,
        rippleEffect: {
          //涟漪特效
          period: 4, //动画时间，值越小速度越快
          brushType: "fill", //波纹绘制方式 stroke, fill
          scale: 3, //波纹圆环最大限制，值越大波纹越大
        },
        label: {
          normal: {
            show: false,
          },
          emphasis: {
            show: false,
          },
        },
        itemStyle: {
          normal: {
            color: "#2BC8FF",
          },
          // emphasis: {
          //   color: "#00B824",
          // },
        },
        symbol: "circle",
        symbolSize: function(item) {
          return [26, 16]; //圆环大小
        },
        symbolOffset: [0, 10],
        data: that.convertData(poiList, poiParams),
        zlevel: 1,
      };
    },
    //点热力图
    addHeatMap(heatData, max){
      //渐变热力图
      var option = this.chart.getOption();
      let areaData = []
      heatData.map((item) => {
        // 扩大热力图效果
        areaData.push(...new Array(4).fill(item));
      });
      var curSeries={
        name: this.heatParams.name + '热力图',
          type:'heatmap',
          minAlpha:0.5,
          coordinateSystem:'geo',
          data:areaData,// [], //[[lon,lat,val],[lon,lat,val]...]
          zlevel: 2,
        };
        option.series.push(curSeries);
        option.visualMap= {
          bottom: 30,
          left: 30,
          color: ['#ff4601', '#fffc00', '#87cffa'],
          min: 0,
          max:max == 0 ? 100 : max,
          calculable: true,
          textStyle: {
              color: '#fff',
              fontSize: 12
          }
        },
        this.chart.setOption(option,true);
    },
    convertData(data, params) {
      var res = [],
        { name, valueField } = params;
      for (var i = 0; i < data.length; i++) {
        let { latitude, longitude, lat, lng } = data[i];
        if(lat && lng){
          var geoCoord = [lng, lat];
        }else if(longitude && latitude){
          var geoCoord = [longitude, latitude];
        }
        if (geoCoord) {
          res.push({
            name: data[i][name] || '',
            value: geoCoord.concat(data[i][valueField]),
            data:data[i]
          });
        }
      }
      return res;
    },
    updateChart() {
      this.dataSeries = [];
      let {poiList, heatData, heatParams} = this
      if (poiList.length > 0) {
        this.dataSeries.push(this.getScatterSeries()); //气泡点
        this.dataSeries.push(this.getScatterSeriesByImg()); //
      }
      var options = this.initOptions();
      this.chart.setOption(options, true);
      if(this.heatData.length > 0){
        let item = _.maxBy(heatData, heatParams.valueField),max = item[heatParams.valueField],data = this.convertData(heatData,heatParams)
        this.addHeatMap(data,max )
      }
    },

    initOptions() {
      var that = this,
        { zoom } = that;
      let mapStyle = this.getMapStyle();
      return {
        backgroundColor: "transparent",
        geo: [
          {
            map: that.currentName == "全国" ? "china" : "map", //'江西', //
            // map: 'china',//'江西', //
            zoom,
            roam: true, //是否允许缩放
            scaleLimit: {
              min: 1,
              max: 8,
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#ffffff", // 'rgb(54,117,237)' // '#1DE9B6'
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "rgba(2, 34, 108, 1)", //'#1DE9B6' //
                },
              },
            },
            itemStyle: mapStyle.itemStyle,
          },
        ],
        series: this.dataSeries,
      };
    },
    getMapStyle() {
      return {
        itemStyle: {
          normal: {
            color: "#ccc",
            areaColor: "rgba(48,197,255,0.2)",
            borderColor: "rgba(48,197,255,1)",
            borderWidth: 2,
            label: {
              show: true,
              textStyle: {
                color: "rgb(48,197,255)",
                fontFamily: "Microsoft YaHei",
              },
            },
            areaColor: {
              type: "radial",
              x: 0.5,
              y: 0.5,
              r: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(48,197,255, 0)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(48,197,255, .2)", // 100% 处的颜色
                },
              ],
              globalCoord: false, // 缺省为 false
            },
            shadowColor: "rgba(48,197,255,1)",
            shadowOffsetX: 5,
            shadowOffsetY: 5,
            shadowBlur: 10,
          },
          emphasis: {
            areaColor: "rgba(48,197,255,0.2)",
            borderColor: "rgba(48,197,255,1)",
            borderWidth: 2,
            label: {
              show: true,
              textStyle: {
                color: "rgb(48,197,255)",
                fontFamily: "Microsoft YaHei",
              },
            },
            areaColor: {
              type: "radial",
              x: 0.5,
              y: 0.5,
              r: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(48,197,255, 0)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(48,197,255, .2)", // 100% 处的颜色
                },
              ],
              globalCoord: false, // 缺省为 false
            },
          },
        },
      };
    },
  },
};
</script>
